export default __webpack_public_path__ + "static/media/Iconss.e0bbeb87.svg";